module.exports = __webpack_public_path__ + "static/img/app5.de32a4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/app5.jpg
// module id = 99sj
// module chunks = 0